import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

export function OrderCard({
  className,
  children,
}: PropsWithChildren<{ className: string }>) {
  return (
    <div className={clsx("bg-white rounded-md border", className)}>
      {children}
    </div>
  );
}
